import { render, staticRenderFns } from "./InvoicesClientContent.vue?vue&type=template&id=5df4c5d9&scoped=true"
import script from "./InvoicesClientContent.vue?vue&type=script&lang=js"
export * from "./InvoicesClientContent.vue?vue&type=script&lang=js"
import style0 from "./InvoicesClientContent.vue?vue&type=style&index=0&id=5df4c5d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4c5d9",
  null
  
)

export default component.exports